import { useEffect } from "react";
import { useLocation } from "wouter";
import { useAuth } from "@/contexts/AuthContext";

interface AuthOnlyRouteProps {
  children: React.ReactNode;
}

/**
 * Signed-in gate with no subscription check.
 *
 * ProtectedRoute bounces anyone without an active/trial/pending subscription to /subscribe.
 * That is right for learning pages, but wrong for pages we want open to every account,
 * such as reporting real PEP results after a subscription has lapsed.
 */
export function AuthOnlyRoute({ children }: AuthOnlyRouteProps) {
  const { user, isLoading } = useAuth();
  const [, setLocation] = useLocation();

  useEffect(() => {
    if (isLoading || user) return;
    const returnTo = encodeURIComponent(window.location.pathname + window.location.search);
    setLocation("/login?returnTo=" + returnTo);
  }, [user, isLoading, setLocation]);

  if (isLoading) return null;
  if (!user) return null;

  return <>{children}</>;
}
